import { Checkbox } from 'antd';
import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';

interface Props {
  onChange: (e: any) => void;
  checked: boolean;
  label?: string;
  name: string;
}

const RoundCheckbox = ({ onChange, checked, label, name}: Props) => {
  return (
    <RoundCheckboxWrapper>
      <Checkbox name={name} type="checkbox" onChange={onChange} checked={checked}>
        {label && label}
      </Checkbox>
    </RoundCheckboxWrapper>
  );
};

export default RoundCheckbox;

const RoundCheckboxWrapper = styled.div`
.ant-checkbox-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:12px;
    .ant-checkbox{
        border-radius : 50%;
        .ant-checkbox-inner{
            border-radius : 50%;
            width:24px;
            height:24px;
            &:after{
                top: 11.5px;
                left: 7px;
                width: 7px;
                height: 12px;
            }
        }
        &+span{
            ${font.body_medium};
            padding:0;
        }
    }
    .ant-checkbox-checked .ant-checkbox-inner{
        background-color: ${color.black2};
        border-color: ${color.black2};
    }
    &:hover{
        .ant-checkbox-inner{
            border-color:#B7B7B7;
            background-color:${color.opacityBlack01};
            box-shadow: 0px 0px 0px 4px ${color.opacityBlack01};
        }
        .ant-checkbox-checked .ant-checkbox-inner{
            background-color: ${color.black2} !important;
            border-color: ${color.black2} !important;
    }
  }
`;
